import React, { useEffect, useState } from 'react'
import Image from '../Image'
import { checkLocale } from '../../utils'
import { useIntl } from 'react-intl'

import {
  partnerDetailsContainer,
  partnerDetailsLogoWrapper,
  partnerDetailsLogo,
  partnerDetailsBlock,
  partnerDetailsContent,
  partnerDetailsItem,
  partnerDetailsWebsite,
} from './index.module.css'

const PartnerDetails = ({
  sortableData,
  sortableComponent,
  sortableFieldItems,
  nodeLocale,
}) => {
  const [component, setComponent] = useState({})
  const [sortableFields, setSortableFields] = useState([])
  const [sortableComponentArray, setSortableComponentArray] = useState([])
  const intl = useIntl()
  const visitWebsite = intl.formatMessage({ id: 'sortable.website' })

  const splitVal = (arr, local) => {
    return arr.map((a) => checkLocale(a, local))
  }

  const getReadableItems = (items) => {
    if (!items) return
    items = splitVal(items, nodeLocale)
    if (items.length <= 1) return items.join(', ')
    return `${items.slice(0, items.length - 1).join(', ')}, ${
      items[items.length - 1]
    }`
  }

  const excludedFields = [
    'title',
    'type',
    'description',
    'logo',
    'headerConfiguration',
    'link',
    'order',
  ]

  const imageStyles = {
    objectFit: 'contain',
    objectPosition: '50% 50%',
  }

  useEffect(() => {
    setSortableFields(sortableFieldItems ? sortableFieldItems.reverse() : [])
    setComponent(
      sortableData.filter(
        ({ node }) => node.contentful_id === sortableComponent.contentful_id
      )[0].node
    )
  }, [])

  useEffect(() => {
    setSortableComponentArray(component ? Object.entries(component) : [])
  }, [component])

  return sortableComponentArray && component ? (
    <div className={partnerDetailsContainer}>
      {component?.logo && (
        <div className={partnerDetailsLogoWrapper}>
          {component?.website ? (
            <a href={component?.website} target="_blank" rel="noreferrer">
              <Image
                classes={partnerDetailsLogo}
                source={component?.logo}
                imageStyles={imageStyles}
              />
            </a>
          ) : (
            <Image
              classes={partnerDetailsLogo}
              source={component?.logo}
              imageStyles={imageStyles}
            />
          )}
        </div>
      )}
      <div className={partnerDetailsBlock}>
        <h2>
          {component?.website ? (
            <a href={component?.website} target="_blank" rel="noreferrer">
              {component?.title}
            </a>
          ) : (
            <span>{component?.title}</span>
          )}
        </h2>
        <div className={partnerDetailsContent}>
          {sortableFields?.map(({ node }, index) =>
            sortableComponentArray.map(([key, value]) => {
              return (
                !excludedFields.includes(key) &&
                node.id === key &&
                value &&
                node.name && (
                  <div
                    key={key}
                    className={partnerDetailsItem}
                    style={{ order: index }}
                  >
                    <h4>{checkLocale(node.name, nodeLocale)}</h4>

                    {node.id !== 'website' ? (
                      <p>{getReadableItems(value)}</p>
                    ) : (
                      <a href={value} target="_blank" rel="noreferrer">
                        <p className={partnerDetailsWebsite}>{visitWebsite}</p>
                      </a>
                    )}
                  </div>
                )
              )
            })
          )}
        </div>
        {sortableComponent.description && (
          <p>{sortableComponent.description.description}</p>
        )}
      </div>
    </div>
  ) : (
    <div />
  )
}

export default PartnerDetails
